import { AxiosInstance } from '@service/axios-instance';

export interface Equipament {
    id: string;
    tid: number;
    tipo: string;
    marca: string;
    modelo: string;
    ano: string;
    setor: string;
    apelido?: string;
    checklist_version?: string;
    firmware_version?: string;
    actual_firmware_version?: string;
    last_fw_request_time?: number;
    last_fw_request_status?: string;
}

export interface FirmwareFile {
    filename: string;
    size_bytes: number;
    modified: string;
    build_date?: string;
    build_time?: string;
}

export async function getEquipaments(db: string, filters: Record<string, string> = {}) {
    const res = await AxiosInstance.post(
        `/equipaments/get_equipaments?db=${encodeURIComponent(db)}`,
        {
            match_filters_dict: filters,
        },
        { withCredentials: true }
    );
    return res.data as Equipament[];
}

export async function getSectors(db: string) {
    const res = await AxiosInstance.get(`/equipaments/get_sectors?db=${encodeURIComponent(db)}`, {
        withCredentials: true
    });
    return res.data as string[];
}

export async function listFirmwares(db: string) {
    const res = await AxiosInstance.get(`/firmware/list`, {
        withCredentials: true
    });
    return res.data.files as FirmwareFile[];
}

export async function uploadFirmware(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    const res = await AxiosInstance.post(`/firmware/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        withCredentials: true
    });
    return res.data;
}

export async function assignFirmwareToDevice(db: string, deviceId: string, firmwareVersion: string) {
    const res = await AxiosInstance.post(`/firmware/assign?db=${encodeURIComponent(db)}`,
        {
            device_id: deviceId,
            firmware_version: firmwareVersion
        },
        { withCredentials: true }
    );
    return res.data;
}

export async function forceFirmwareUpdate(db: string, deviceId: string) {
    const res = await AxiosInstance.post(`/firmware/force?db=${encodeURIComponent(db)}`,
        {
            device_id: deviceId,
        },
        { withCredentials: true }
    );
    return res.data;
}

export async function refreshActualFirmwares(db: string) {
    const res = await AxiosInstance.post(`/firmware/refresh_actual_versions?db=${encodeURIComponent(db)}`, {}, {
        withCredentials: true
    });
    return res.data;
}

export async function clearFirmwareStatus(db: string) {
    const res = await AxiosInstance.post(`/firmware/clear_status?db=${encodeURIComponent(db)}`, {}, {
        withCredentials: true
    });
    return res.data;
}
